// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1fMjc","selects":"Documents_selects__2Wxt1"};